import React, {useEffect, useMemo, useRef, useState} from "react";
import "./formStyle.css";

import {Button} from "antd";
import {BigInput} from "./bigInput/BigInput";
import FormSection from "./formSection/FormSection";
import FieldContainer from "./fieldContainer/FieldContainer";
import ButtonGroup from "./buttonGroup/ButtonGroup";
import {FlowTypeProps} from "../../types/FlowTypeProps";
import BigPicker from "./bigPicker/BigPicker";
import {FlowTriggerProps} from "../../types/FlowTriggerProps";
import useAppContext from "../../hooks/useAppContext";
import useUserContext from "../../hooks/useUserContext";
import useToast from "../../hooks/useToast";
import {isFlowFormValid} from "../modals/flowModals/FlowFormValidator";
import {CartIcon} from "../../assets/icons/CartIcon";
import {DEFAULT_FORM_VALUES, FormValuesProps} from "../modals/flowModals/NewFlowModal";
import PurchaseCompletedIcon from "../../assets/icons/PurchaseCompletedIcon";
import NewCustomerIcon from "../../assets/icons/NewCustomerIcon";
import ShippingAcknowledgedIcon from "../../assets/icons/ShippingAcknowledged";
import ClickIcon from "../../assets/icons/ClickIcon";

interface NewFlowFormProps {
    onFlowCreation: (flowId: number, flowTriggerId: number) => void;
    onClose: () => void;
}

const NewFlowForm = ({ onFlowCreation, onClose }: NewFlowFormProps) => {
    const [formValues, setFormValues] = useState<FormValuesProps>(DEFAULT_FORM_VALUES);
    const [formErrors, setFormErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { actions: { createFlow, loadFlows }, data: { flowTypes, flowTriggers } } = useAppContext();
    const { selectedDomain } = useUserContext();
    const { showToast } = useToast();

    const onCreateNewFlow = async () => {
        setIsLoading(true);
        const errors = isFlowFormValid(formValues);
        console.log("errors: ", errors);
        if(errors?.length) {
            //TODO: Error handling;
            console.log("errors: ", errors);
        }
        if(selectedDomain && !errors.length && formValues.flowTriggerId && formValues.distribution) {
            try {
                const response = await createFlow(selectedDomain, {
                    title: formValues.title,
                    flowTriggerId: formValues.flowTriggerId,
                    distribution: formValues.distribution,
                    active: formValues.active,
                });
                setIsLoading(false);
                onFlowCreation(parseInt(response.data.flowId), formValues.flowTriggerId);
            } catch (error) {
                console.log("error: ", error);
                showToast({ text: 'An unknown error occurred while saving your template'});
            }
        } else {
            showToast({ text: errors?.length ? errors[0] : 'An unknown error occurred while saving your template'});
        }
        setIsLoading(false);
        return false;
    }

    const onFormUpdate = (newFormValues: any) => {
        !formErrors.length && setFormErrors([]);

        setFormValues(newFormValues);
    }

    useEffect(() => {
        setFormValues({ ...formValues, flowTriggerId: formValues.flowTypeId === 1 ? 1 : null });
    }, [formValues.flowTypeId]);

    const getFlowTypeIcon = (flowTriggerId: number) => {
        if(flowTriggerId === 1) return <CartIcon width={36} color="#1575fb" />;
        if(flowTriggerId === 5) return <PurchaseCompletedIcon width={36} color="#1575fb" />;
        if(flowTriggerId === 6) return <NewCustomerIcon width={36} color="#1575fb" />;
        if(flowTriggerId === 8) return <ShippingAcknowledgedIcon width={36} color="#1575fb" />;
        if(flowTriggerId === 11) return <ClickIcon width={36} color="#1575fb" />;
    }

    const getFlowTypeIdTriggers = (flowTypeId: number | null) => {
        if(!flowTypeId) return [];
        // const flowType = flowTypes.data.find(flowType => flowType[flowTypeId])
        const flowType = flowTypes.data.find((flowType: any) => flowType.id === flowTypeId);
        const availableTriggers = flowTriggers.data.filter((trigger: any) => trigger[flowType.title] === 1);
        return availableTriggers;
    }

    return (
        <div className="new-flow-form-container">
            <BigInput placeholder="Title" description="Choose a clear and meaningful title to easily identify and manage your flow later." value={formValues.title} setValue={(newVal: string) => onFormUpdate({...formValues, title: newVal })} />

            <FormSection title="Set the Trigger for Your Flow" className="trigger-selection">
                <FieldContainer>
                    <ButtonGroup
                        items={flowTriggers.data.map((flowTrigger: FlowTypeProps) => ({
                            id: flowTrigger.id,
                            title: flowTrigger.title,
                            description: flowTrigger.description,
                            icon: getFlowTypeIcon(flowTrigger.id),
                            isSelected: formValues.flowTriggerId === flowTrigger.id
                        }))}
                        onClick={(newId: number | string) => {
                            onFormUpdate({ ...formValues, flowTriggerId: newId })
                        }}
                    />
                </FieldContainer>
            </FormSection>

            {/*<BigInput*/}
            {/*    maxLength={3}*/}
            {/*    type="number"*/}
            {/*    value={formValues.distribution?.toString() || ''}*/}
            {/*    setValue={(newVal) => onFormUpdate({...formValues, distribution: !parseInt(newVal) || parseInt(newVal) <= 100 ? parseInt(newVal) : formValues.distribution })}*/}
            {/*    description="Set the distribution rate for this flow (if other flows exist). A higher rate (0-100) increases the likelihood of this flow being selected when the event is triggered."*/}
            {/*/>*/}
            <div className="action-bar">
                <Button size="large" type="text" className="page-header-secondary" onClick={onClose}>Cancel</Button>
                <Button disabled={!!isFlowFormValid(formValues).length} size="large" type="primary" onClick={onCreateNewFlow}>Create Flow</Button>
            </div>
        </div>
    );
}

export default NewFlowForm;